export default { sha: '399ebd4f7e4d1421a62ce943d033d2782ba5bc33', buildNumber: 'undefined' }
